module.exports = __webpack_public_path__ + "static/media/stone_modal.850196fd.png";